import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const UserDropdownLanguageFlag = styled.img`
  width: 24px;
  height: auto;
`

export const UserDropdownLanguageText = styled.p`
  color: ${COLORS.secondarySemiDark};
  font-size: 14px;
  font-weight: 500;
`
